/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type useCommentCountEvent_story = {
    readonly id: string;
    readonly url: string;
    readonly settings: {
        readonly mode: STORY_MODE;
    };
    readonly " $refType": "useCommentCountEvent_story";
};
export type useCommentCountEvent_story$data = useCommentCountEvent_story;
export type useCommentCountEvent_story$key = {
    readonly " $data"?: useCommentCountEvent_story$data;
    readonly " $fragmentRefs": FragmentRefs<"useCommentCountEvent_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCommentCountEvent_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '514e19a33e69fa7ef8d87784b76dd846';
export default node;
